import React from 'react';
import { Pane, Strong, Text } from 'evergreen-ui';
import { useLocation } from 'react-router-dom';

export function NotFound() {
  const location = useLocation();
  return (
    <Pane padding=".5rem">
      <Strong>Страница не найдена:</Strong>
      {' '}
      <Text>{location.pathname}</Text>
    </Pane>
  );
}
